import React from 'react';

import { GridV2, GridV2Props } from '_lib/components/GridV2/GridV2';
import { Typography } from '_lib/components/Typography/Typography';

export const KeyValueGrid = (
  props: GridV2Props & {
    gridItemSize: number;
    keyValueArray: Array<{ label: string; textOrComponent: string | React.ReactElement }>;
  }
) => {
  const { keyValueArray, gridItemSize, ...gridProps } = props;

  return (
    <GridV2 container spacing={2} {...gridProps}>
      {keyValueArray.map((mapProps, index) => {
        const { label, textOrComponent } = mapProps;
        return (
          <GridV2 key={index} size={gridItemSize}>
            <Typography text={label} variant='body1Bold' />
            {typeof textOrComponent === 'string' ? <Typography text={textOrComponent} /> : textOrComponent}
          </GridV2>
        );
      })}
    </GridV2>
  );
};
